import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"across the pond"
LOO
toilet
#lotie

cHipS
FriES
LOrry
TrUcK
NAppy
DiApEr
#ricyp

lIft
eleVatOR
flat
aPaRtMeNt
#lfate`

const id = 'british-0.0'

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}`);
}

export const british: StoryLevelData = parsed.levelData;